// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper {
  width: 100% !important;
}

.swiper-wrapper {
  display: flex !important;
  gap: 24px !important;
}

.swiper-slide {
  margin: 0 !important;
  width: 355px !important;
}

.bd {
  border-radius: 14.571px;
  background: var(--White, #fdfdfd);
  box-shadow: 0px 1.214px 2.429px 0px rgba(16, 24, 40, 0.05);
}

.trendingContainer {
  display: flex;
  width: 100%; /* Set a maximum width for larger screens */
  margin-left: auto;
  margin-right: auto;
  padding: 80px 13.103%;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  gap: 36px;
}

.noeventscontainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* min-height: 100vh; */
  width: 100%;
  padding: 0;
  margin: 0; /* Remove margins that may be inherited */
  box-sizing: border-box;
  color: #101010; /* Black text */
  font-size: 22px;
}

.noeventsimage {
  width: 118px;
  height: 165px;
  flex-shrink: 0;
  background: linear-gradient(180deg, #fff 0%, rgba(255, 255, 255, 0.2) 50%, #fff 100%);
}

.sw .swiper-wrapper {
  display: flex !important;
  gap: 24px !important;
  justify-content: space-between;
}

@media screen and (max-width: 650px) {
  .swiper-wrapper {
    gap: 8px !important;
  }
  .swiper-slide {
    margin: 0 !important;
    width: 330px !important;
  }
  .trendingContainer {
    display: flex;
    padding: 40px 24px;
    padding-right: 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
  }
  .noeventsimage {
    width: 200px;
    height: 200px;
  }
  .noeventsbutton {
    margin-top: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/landing-page/components/Trending/style.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;;AAEA;EACE,wBAAA;EACA,oBAAA;AACF;;AAEA;EACE,oBAAA;EACA,uBAAA;AACF;;AAEA;EACE,uBAAA;EACA,iCAAA;EACA,0DAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA,EAAA,2CAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA,EAAA,yCAAA;EACA,sBAAA;EACA,cAAA,EAAA,eAAA;EACA,eAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,qFAAA;AACF;;AAQE;EACA,wBAAA;EACA,oBAAA;EACA,8BAAA;AALF;;AAUA;EACE;IACE,mBAAA;EAPF;EAUA;IACE,oBAAA;IACA,uBAAA;EARF;EAWA;IACE,aAAA;IACA,kBAAA;IACA,gBAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,SAAA;EATF;EAYA;IACE,YAAA;IACA,aAAA;EAVF;EAaA;IAKE,gBAAA;EAfF;AAIF","sourcesContent":[".swiper {\n  width: 100% !important;\n}\n\n.swiper-wrapper {\n  display: flex !important;\n  gap: 24px !important;\n}\n\n.swiper-slide {\n  margin: 0 !important;\n  width: 355px !important;\n}\n\n.bd {\n  border-radius: 14.571px;\n  background: var(--White, #fdfdfd);\n  box-shadow: 0px 1.214px 2.429px 0px rgba(16, 24, 40, 0.05);\n}\n\n.trendingContainer {\n  display: flex;\n  width: 100%; /* Set a maximum width for larger screens */\n  margin-left: auto;\n  margin-right: auto;\n  padding: 80px 13.103%;\n  box-sizing: border-box;\n  flex-direction: column;\n  align-items: center;\n  gap: 36px;\n}\n\n.noeventscontainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  /* min-height: 100vh; */\n  width: 100%;\n  padding: 0;\n  margin: 0; /* Remove margins that may be inherited */\n  box-sizing: border-box;\n  color: #101010; /* Black text */\n  font-size: 22px;\n}\n\n.noeventsimage {\n  width: 118px;\n  height: 165px;\n  flex-shrink: 0;\n  background: linear-gradient(\n    180deg,\n    #fff 0%,\n    rgba(255, 255, 255, 0.2) 50%,\n    #fff 100%\n  );\n}\n\n.sw{\n  .swiper-wrapper {\n  display: flex !important;\n  gap: 24px !important;\n  justify-content: space-between;\n}\n\n}\n\n@media screen and (max-width: 650px) {\n  .swiper-wrapper {\n    gap: 8px !important;\n  }\n\n  .swiper-slide {\n    margin: 0 !important;\n    width: 330px !important;\n  }\n\n  .trendingContainer {\n    display: flex;\n    padding: 40px 24px;\n    padding-right: 0;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 24px;\n  }\n\n  .noeventsimage {\n    width: 200px;\n    height: 200px;\n  }\n\n  .noeventsbutton {\n    margin-top: 2px;\n  }\n\n  .noeventsbutton {\n    margin-top: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
